var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCallToApi(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "50px",
    height: "50px",
    viewBox: "0 0 50 50",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "02C1F129-9F5A-4AB1-BB95-2BAC139D1D0D") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "path-1",
    x: 0,
    y: 0,
    width: 50,
    height: 50
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.507592,28.8909159 L16.507592,38.3386154 L19.1501206,38.3386154 L14.736753,44.4199939 L10.3240239,38.3386154 L12.9665525,38.3386154 L12.9665525,28.8909159 L16.507592,28.8909159 Z M34.4101074,26.2586581 L38.8234751,32.3400366 L36.1803078,32.3400366 L36.1803078,41.7877362 L32.6392684,41.7877362 L32.6392684,32.3400366 L29.9967397,32.3400366 L34.4101074,26.2586581 Z M21.6099458,5 C27.924346,5 33.2413387,9.17416421 34.8402074,14.855973 C34.9665331,14.8485917 35.0947443,14.844901 35.2229555,14.844901 C38.8967712,14.844901 41.8767382,17.7531604 41.8927646,21.3451191 C42.1689842,21.3082123 42.4527457,21.2888362 42.7402781,21.2888362 C46.1972661,21.2888362 49,24.0319375 49,27.4153725 C49,30.7988075 46.1972661,33.5419088 42.7402781,33.5419088 L41.1621494,33.5419088 L35.5679943,25.8329915 C35.2776337,25.4334749 34.8468065,25.2148019 34.3452746,25.2148019 C33.8437426,25.2148019 33.4129154,25.4334749 33.1225548,25.8329915 L27.527457,33.5419088 L18.1190196,33.5419088 L18.1190196,29.0540364 C18.1190196,28.2457765 17.4449682,27.5860667 16.6191374,27.5860667 L12.7250373,27.5860667 C11.8982638,27.5860667 11.2251552,28.2457765 11.2251552,29.0540364 L11.2251552,33.5419088 L10.8075261,33.5419088 C6.12687564,33.5419088 1,29.8290802 1,25.2489407 C1,21.1753476 4.00070705,17.7882219 7.95639877,17.0879145 C8.64364836,10.3007457 14.4942258,5 21.6099458,5 Z",
    id: "path-3"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Settings-Integrations",
    transform: "translate(-519.000000, -1434.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "CallAPI",
    transform: "translate(519.000000, 1434.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Mask"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "mask-4",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-3"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Mask",
    fill: "#090F36",
    xlinkHref: "#path-3"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCallToApi);
export default __webpack_public_path__ + "static/media/CallToAPI.c4a49c736f942e6a4569f0f52a8e7253.svg";
export { ForwardRef as ReactComponent };